declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  // Meta Pixel base code
  const f = window
  const b = document
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  // Append to head instead of relying on existing script tags
  b.head.appendChild(t)

  // Initialize with Pixel ID and fire PageView
  window.fbq('init', '1246394330793823')
  window.fbq('track', 'PageView')

  initialized = true
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Bedtime Pass + Boundary Script Kit',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
